/**
 * TrustBadges — inline trust signals for storefront checkout.
 *
 * Displays SSL, encryption, and money-back guarantee badges to reduce
 * checkout abandonment. Uses dark-violet glass aesthetic.
 */
import React from 'react';
import { Lock, ShieldCheck, RotateCcw, CreditCard } from 'lucide-react';

const BADGES = [
  { id: 'ssl',      icon: Lock,        label: 'SSL Secured',      hint: '256-bit encryption' },
  { id: 'stripe',   icon: CreditCard,  label: 'Powered by Stripe', hint: 'PCI-DSS Level 1' },
  { id: 'guarantee', icon: ShieldCheck, label: 'Buyer Protection',  hint: 'Order guarantee' },
  { id: 'returns',  icon: RotateCcw,   label: 'Easy Returns',     hint: 'Per vendor policy' },
];

export default function TrustBadges({ compact = false }) {
  return (
    <div
      className={`grid ${compact ? 'grid-cols-4 gap-1.5' : 'grid-cols-2 sm:grid-cols-4 gap-2.5'}`}
      data-testid="checkout-trust-badges"
    >
      {BADGES.map((b) => (
        <div
          key={b.id}
          className="flex flex-col items-center text-center gap-1 px-2 py-3 rounded-xl border border-white/8 bg-white/[0.03] backdrop-blur"
          data-testid={`trust-badge-${b.id}`}
        >
          <div className="w-8 h-8 rounded-lg bg-emerald-500/15 border border-emerald-400/25 flex items-center justify-center">
            <b.icon size={14} className="text-emerald-300" />
          </div>
          <p className="text-[10px] font-bold text-white/85 leading-tight">{b.label}</p>
          {!compact && <p className="text-[9px] text-white/45 leading-tight">{b.hint}</p>}
        </div>
      ))}
    </div>
  );
}
